/* eslint-disable no-undef */
import React from 'react'
import { Paper, makeStyles, Grid, Box } from '@material-ui/core'
import ExtraElement from './ExtraElement'

const useStyles = makeStyles(theme => ({
    root: {
        color: theme.termsColor ? theme.termsColor : 'rgba(0, 0, 0, 0.45)',
        textAlign: 'center',
        letterSpacing: 0.5,
        textTransform: 'uppercase',
        fontSize: '0.7rem',
        margin: 'auto'
    },
    paper: {
        background: 'rgba(255,255,255,0.95)',
        boxShadow: '0 3px 5px rgba(0,0,0,0.1)',
        marginTop: theme.spacing(3),
        borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
        [theme.breakpoints.down(600)]: {
            borderRadius: 0 + 'px!important'
        }
    },
    title: {
        fontWeight: 600,
        fontSize: '1.1rem',
        lineHeight: '1.4rem'
    }
}))

function ExtraElements({}) {
    const classes = useStyles()

    return (
        <>
            <Paper className={classes.paper} elevation={1} id={'information'}>
                <Box px={{ xs: 2, sm: 3 }} py={3}>
                    <Box className={classes.title} mb={0.75}>
                        Mietityttääkö osallistuminen?
                    </Box>
                    <Box fontWeight={400}>
                        Se on hyvin järkevää. Anna meidän kuitenkin kertoa, miksi suomalainen LeadSpark Oy (2775435-5) ja sen palvelu Kilpailu.fi
                        ansaitsee luottamuksesi.
                    </Box>
                </Box>
                <Box px={{ xs: 2, sm: 3 }} pb={0.5}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                            <ExtraElement
                                imageSrc={'/img/avainlippu.png'}
                                title={'Olemme 100% suomalainen ja vastuullinen.'}
                                description={'Emme toimita tietojasi kolmansille osapuolille ilman suostumustasi.'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <ExtraElement
                                imageSrc={'/img/ssl.png'}
                                title={'Osallistuminen on turvallista ja vie vain minuutin.'}
                                description={'Business Finland tukee tuote&shy;kehitystämme. Kilpailumme ovat tehokkaita ja turvallisia.'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <ExtraElement
                                imageSrc={'/img/asml.png'}
                                title={'ASML valvoo ja kehittää toimintaamme.'}
                                description={'Kaikki toimintamme on Suomen Asiakkuus&shy;markkinointi&shy;liiton tarkistamaa ja ohjaamaa.'}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box px={{ xs: 2, sm: 3 }} pb={{ xs: 3, sm: 2.5 }} pt={{ xs: 4, sm: 2.5 }}>
                    <Box fontWeight={400}>
                        Tutustu toimintaamme ja lue meistä lisää osoitteessa:{' '}
                        <a href="https://www.leadspark.fi" target="_blank">
                            LeadSpark.fi
                        </a>
                    </Box>
                </Box>
            </Paper>
            <Paper className={classes.paper} elevation={1} id={'information'}>
                <Box px={{ xs: 2, sm: 3 }} py={3}>
                    <Box className={classes.title} mb={0.75}>
                        Viimeisimmät voittajat
                    </Box>
                    <Box fontWeight={400}>Arvontamme suoritetaan heti kilpailun päätyttyä. Alla viimeisimmät voittajat:</Box>
                </Box>
                <Box px={{ xs: 2, sm: 3 }} pb={0.5}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Tankki täyteen polttoainetta, arvo 150€'}
                                description={'<b>Kari S. (Lahti)</b><br>31.5.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'200€ Vappurahaa - 1.5.2022'}
                                description={
                                    '<b>Jussi J. (Inkeroinen)</b>: <i>“Aivan mahtavaa voittaa joskus jotain kiitos vappuarvonta”</i>'
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'2x24-pack NOCCOa - 30.4.2022'}
                                description={
                                    '<b>Tiiu K. (Kymenlaakso)</b>: <i>“Voittaminen tuli aivan yllätyksenä, mutta oli erittäin positiivinen yllätys! Piristi päivää mukavasti!”</i>'
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'PlayStation 5 -pelikonsoli'}
                                description={'<b>Seija H. (Pohjois-Pohjanmaa)</b><br>30.4.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Kahvit vuodeksi'}
                                description={'<b>Teuvo K. (Uusimaa)</b><br>31.3.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Vuoden pääpalkinto, 1000€'}
                                description={'<b>Auli P. (Etelä-Savo)</b><br>1.1.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Uudenvuoden arvonta, 200€'}
                                description={'<b>Keijo S (Uusimaa)</b><br>1.1.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Jouluarvonta, 200€'}
                                description={'<b>Eero V. (Pohjois-Pohjanmaa)</b><br>21.12.2021'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'2. Black Friday -arvonta, 200€'}
                                description={'<b>Marko R. (Varsinais-Suomi)</b><br>26.11.2021'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner1.png'}
                                title={'1000€ Matkalahjakortti haluamaasi kohteeseen kotimaassa - 1.9.2021'}
                                description={
                                    '<b>Outi T. (Uusimaa)</b>: <i>Kun sain puhelun voitosta, olin ensin epäuskoinen ja kuvittelin joutuneeni huijauksen kohteeksi. Mutta kun voittosumma tuli tililleni, oli minunkin pakko uskoa: “Kerrankin minä, jee!”</i>'
                                }
                            />
                        </Grid>
                        {false &&
                        <>
                          <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Netflix-lahjakortti koko vuodeksi'}
                                description={'<b>Saila K. (Lahti)</b><br>15.8.2021'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Samsung Galaxy S20 5G 128gt'}
                                description={'<b>Sinikka P. (Hämeenlinna)</b><br>31.6.2021'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'1000€ Paljujuhannus tarjoiluineen'}
                                description={'<b>Kati P. (Oulu)</b><br>1.6.2021'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'250€ Saunailta MM-kisäeväineen'}
                                description={'<b>Liisa R. (Pohjois-Pohjanmaa)</b><br>1.5.2021'}
                            />
                        </Grid>
                        </>}
                    </Grid>
                </Box>
                <Box px={{ xs: 2, sm: 3 }} pb={{ xs: 3, sm: 2.5 }} pt={{ xs: 4, sm: 2.5 }}>
                    <Box fontWeight={400}>
                        <a href="https://www.kilpailu.fi/fi/voittajat/" target="_blank">
                            Katso lisää voittajia
                        </a>
                    </Box>
                </Box>
            </Paper>
        </>
    )
}

export default ExtraElements
